module.exports = __webpack_public_path__ + "img/google-pay-mark_800-cropped.e5042e24.svg";